module.exports = __webpack_public_path__ + "img/logo50px.3db991be.svg";